import styled from "styled-components";
import { File } from "../../files.types";
import ActivityFeed from "@/components/ActivityFeed/ActivityFeed";
import { useGetFileLogs } from "../../files.query";

const StyledContainer = styled.div`
  margin-top: 15px;

  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 0px;
`;

export const Activity: React.FC<{ defaultData: File }> = ({ defaultData }) => {
  const { data: logs, isLoading } = useGetFileLogs({
    uuid: defaultData.uuid,
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <StyledContainer>
      <ActivityFeed logs={logs?.data || []} variant="card" />
    </StyledContainer>
  );
};
